import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResetPasswordModel } from '../../../model/reset-password-model';
import { AuthService } from '../../../services/auth.service';
import { SharedModule } from '../../../shared/shared-module.ts.module';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, SharedModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  resetForm!: FormGroup;
  token!: string;
  email!: string;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    this.email = this.route.snapshot.queryParamMap.get('email') || '';

    this.resetForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(128)]],
      confirmPassword: ['', [Validators.required]],
    }, { validators: ResetPasswordComponent.passwordsMatch });

    void this.router.navigate([], { replaceUrl: true, queryParams: {} });
  }

  private static passwordsMatch(control: AbstractControl): ValidationErrors | null {
    return control.get('newPassword')?.value === control.get('confirmPassword')?.value
      ? null
      : { passwordsMismatch: true };
  }

  onSubmit() {
    if (this.resetForm.invalid) return;

    const { newPassword, confirmPassword } = this.resetForm.value;
    if (!this.token || !this.email) {
      alert('Link de redefinicao invalido ou incompleto.');
      return;
    }


    if (newPassword !== confirmPassword) {
      alert('As senhas não coincidem.');
      return;
    }

    const model: ResetPasswordModel = {
      email: this.email,
      newPassword: newPassword,
      token: this.token
    }
    this.spinner.show();

    this.authService.resetPassword(model)
      .subscribe({
        next: () => {
          alert('Senha alterada com sucesso.');
          this.spinner.hide();
          this.router.navigate(['/login']);
        },
        error: () => {
          alert('Erro ao alterar a senha.');
          this.spinner.hide();
        }
      });
  }
}
